import Vue from 'vue'
import to from 'await-to-js'
import client from '@/api/client'
import HOMEPAGE_QUERY from '@/api/gql/homepage/query/homepage.gql'

const DEFAULT_TEMPLATE = 'C'

const getCategorySliderData = vm => {
  // TODO: #3581 ⁃ Provide category slider data via GraphQl
  // TODO: #3407 ⁃ Add final hard-coded data for category slider
  const getFullUrl = vm.$store.getters['page/getFullUrl']
  const ctaText = vm.$t('discover_cta')
  const CATEGORY_SLIDER_DATA = [
    {
      title: vm.$t('latest'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/1vLUHTKoso5ZA9SceVU30q/8d6dc3a0f9378e747b5715aadf11a743/category_slider-fw22-new_arrivals.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/?release_date=new-arrivals') }],
    },

    {
      title: vm.$t('gift_ideas'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/9F1NOcqZ0KOxCNTZrAO7l/65e04881a1d176fa5f9c399f922b68cf/category_slider-fw22-gift_ideas.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/gift-ideas') }],
    },

    {
      title: vm.$t('shoe_finder'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/2oa58T6ILmCXtoH2fb0yW2/dc4b5e736e4a1c8066fe050c62ee7c13/category_slider-fw22-shoe_finder.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/shoe-finder') }],
    },

    {
      title: vm.$t('mens'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/4PJVBcRxpX3sW0kdNcWUI5/cc6f46d5ec518e130260482b18988534/category_slider-fw22-men.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/mens') }],
    },

    {
      title: vm.$t('womens'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/65t8SKmRS8SuABMPJpaET5/25e15614d3517a45fbb871068877cfcb/category_slider-fw22-women.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/womens') }],
    },

    {
      title: vm.$t('cloud_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/3t7Z5WgFLxSK0SZCzIggRN/bf4e7aa466739d6bf3016adf7997e977/category_slider-fw22-cloud_collection.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/cloud') }],
    },

    {
      title: vm.$t('accessories'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/4vnowyX22gsx6IHO3HXpNj/8d2c4e8948d00c2974e05d7a35c7c960/category_slider-fw22-accessories.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/accessories') }],
    },

    {
      title: vm.$t('road_running'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/29tNa3SCwSQpHQtibYqu4I/a3d9334fed181a3844cc855430c45984/category_slider-fw22-running_shoes.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/shoes/road') }],
    },

    {
      title: vm.$t('bestsellers'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/3dmLvDRpwxrBWhUnPMOdRT/be8b4d257163f31fa0ada2f5cf31f9ab/category_slider-fw22-best_sellers.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/?sort=bestseller') }],
    },

    {
      title: vm.$t('outdoor_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/4HpO1ffCSEy5MCePYMYqN4/34153d7c2e48e975294ecb6f0ffed62b/category_slider-fw22-outdoor_collection.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/outdoor') }],
    },
  ]

  return CATEGORY_SLIDER_DATA
}

const HomepageService = {
  async fetch(vm) {
    const [error, result] = await to(client.query({ query: HOMEPAGE_QUERY }))
    if (error) Vue.rollbar.error(error.message, error)
    const homepage = result?.data?.homepage || {}
    if (!homepage.template) homepage.template = DEFAULT_TEMPLATE
    return {
      ...homepage,
      categorySlider: getCategorySliderData(vm, homepage.template),
    }
  },
}

export default HomepageService
